module.exports = __webpack_public_path__ + "img/campana.f4723e2a.png";